import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ListFilter } from "lucide-react";
import { Button } from "../../components/ui/button/index.js";
import { Popover, PopoverContent, PopoverTrigger } from "../../components/ui/popover/index.js";
import { cn } from "../../lib/utils.js";

export function ReportMoreFilters({
  activeCount = 0,
  children,
  testId = "reports-more-filters",
}: {
  activeCount?: number;
  children: React.ReactNode;
  testId?: string;
}): React.JSX.Element {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          type="button"
          size="sm"
          variant="outline"
          className={cn(
            "hidden h-8 gap-1.5 text-[0.75rem] md:inline-flex",
            activeCount > 0 && "border-accent/30 bg-accent/5",
          )}
          data-testid={testId}
        >
          <ListFilter size={14} aria-hidden="true" />
          {t("reports.chrome.moreFilters")}
          {activeCount > 0 ? (
            <span className="inline-flex min-w-5 items-center justify-center rounded-full bg-accent px-1.5 text-[0.6875rem] font-semibold text-white tabular-nums">
              {activeCount}
            </span>
          ) : null}
        </Button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-[min(20rem,92vw)] p-2.5">
        <div className="grid gap-2" data-testid={`${testId}-panel`}>
          <p className="m-0 text-[0.6875rem] font-semibold text-muted">
            {t("reports.chrome.moreFilters")}
          </p>
          <div className="grid gap-1.5">{children}</div>
        </div>
      </PopoverContent>
    </Popover>
  );
}
